import { useState, useCallback, useEffect } from 'react'
import { APIProvider, Map, Marker } from '@vis.gl/react-google-maps'

const containerStyle = {
  width: '100%',
  height: '360px',
  marginBottom: '3px'
}

export default function MapPicker ({ initialCoords, onLocationSelected }) {
  const [position, setPosition] = useState ({
    lat: initialCoords.latitude,
    lng: initialCoords.longitude
  })

  const ENV = import.meta.env.REACT_APP_ENVIRONMENT || 'production'

  const apiKey = ENV === 'production'
    ? import.meta.env.REACT_APP_PROD_GOOGLE_MAPS_API_KEY
    : import.meta.env.REACT_APP_DEV_GOOGLE_MAPS_API_KEY

  useEffect (() => {
    if (initialCoords.latitude !== position.lat || initialCoords.longitude !== position.lng) {
      setPosition ({
        lat: initialCoords.latitude,
        lng: initialCoords.longitude
      })
    }
  }, [initialCoords.latitude, initialCoords.longitude])

  const handleDragEnd = useCallback ((e) => {
    const lat = e.latLng.lat ()
    const lng = e.latLng.lng ()
    setPosition ({ lat, lng })
    onLocationSelected ({ latitude: lat, longitude: lng })
  }, [onLocationSelected])

  const isValidPosition = (
    typeof position.lat === 'number' &&
    typeof position.lng === 'number' &&
    !isNaN (position.lat) &&
    !isNaN (position.lng)
  )

  if (!isValidPosition) {
    return null
  }

  return (
    <APIProvider apiKey={apiKey}>
      <Map
        style={containerStyle}
        defaultCenter={position}
        defaultZoom={16}
        gestureHandling="greedy"
        disableDefaultUI={false}
      >
        <Marker
          position={position}
          draggable={true}
          onDragEnd={handleDragEnd}
        />
      </Map>
    </APIProvider>
  )
}